<div [class.expanded]="expanded()" class="content-wrapper">
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>